import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-brand-black z-50" }
const _hoisted_2 = { class: "flex p-4 border-b border-brand-dark-gray border-opacity-80" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current text-white w-6 h-6 p-0.5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_4 = { class: "flex relative" }
const _hoisted_5 = {
  key: 0,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin m-auto h-5 w-5 text-brand-lime",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col p-4 space-y-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl text-white" }, "Gallery", -1)
const _hoisted_10 = { class: "flex grid gap-2 grid-cols-3" }
const _hoisted_11 = {
  key: 0,
  class: "animate-spin h-7 w-7 text-white m-auto",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "m-auto",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5301 5.5L12.5117 19.5",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.5 12.5H19.5",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("rect", {
  width: "25",
  height: "25",
  rx: "12.5",
  fill: "white"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.8921 7L12.5 11.3921L8.10786 7L7 8.10786L11.3921 12.5L7 16.8921L8.10786 18L12.5 13.6079L16.8921 18L18 16.8921L13.6079 12.5L18 8.10786L16.8921 7Z",
  fill: "black"
}, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_buttons, { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_ion_button, {
                      onClick: _ctx.saveChanges,
                      class: "!text-xl text-brand-lime"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.saving)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addPhoto && _ctx.addPhoto(...args))),
                class: "w-full h-28 bg-brand-dark-gray rounded-md flex"
              }, [
                (_ctx.busy)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
                  : _createCommentVNode("", true),
                (!_ctx.busy)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryPhotos, (photo, pIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIndex,
                  style: _normalizeStyle({
                'background-image' : `url('${photo}')`
              }),
                  class: "w-full h-28 bg-brand-dark-gray bg-cover bg-center rounded-md flex p-2"
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    onClick: ($event: any) => (_ctx.removePhoto(pIndex)),
                    class: "mt-auto ml-auto",
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _hoisted_22, 8, _hoisted_19))
                ], 4))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}